import { DollarCircle } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconDollarCircle12Line = createIcon(DollarCircle, 12, "Line");
export const IconDollarCircle16Line = createIcon(DollarCircle, 16, "Line");
export const IconDollarCircle20Line = createIcon(DollarCircle, 20, "Line");
export const IconDollarCircle24Line = createIcon(DollarCircle, 24, "Line");
export const IconDollarCircle32Line = createIcon(DollarCircle, 32, "Line");
export const IconDollarCircle48Line = createIcon(DollarCircle, 48, "Line");
export const IconDollarCircle64Line = createIcon(DollarCircle, 64, "Line");
